var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      directives: [
        {
          name: "drawerloading",
          rawName: "v-drawerloading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: _vm.titleInternalKey ? _vm.$t(_vm.titleInternalKey) : _vm.title,
        "before-close": _vm.cancelHandle,
        visible: _vm.visible,
        direction: "rtl",
        size:
          parseInt(_vm.size) > parseInt(_vm.maxWidth) ? _vm.maxWidth : _vm.size,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("yxt-empty", { attrs: { "empty-text": _vm.warnMsg } }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancelHandle } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }